import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RevolutionizedHeroSection.css';

const RevolutionizedHeroSection: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <section className="revolutionized-hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1>
              Cross-Border Payments, <span className="highlight">Revolutionized.</span>
            </h1>
            <div className="benefits-list">
              <div className="benefit-item">
                <div className="check-icon">✓</div>
                <span>Send money globally in minutes - not days.</span>
              </div>
              <div className="benefit-item">
                <div className="check-icon">✓</div>
                <span>Pay less than 1% in fees.</span>
              </div>
              <div className="benefit-item">
                <div className="check-icon">✓</div>
                <span>No banks. No borders. Just business.</span>
              </div>
            </div>
            <div className="hero-cta">
              <a href="https://kavodax.gitbook.io/kavodax-docs/" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Learn More</a>
            </div>
          </div>
          <div className="hero-visual">
            <div className="visual-container">
              <div className="laptop-mockup">
                <div className="laptop-screen">
                  <div className="app-interface">
                    <div className="nav-bar"></div>
                    <div className="app-content"></div>
                  </div>
                </div>
              </div>
              <div className="floating-cards">
                <div className="card purple-card">
                  <div className="card-logo">K</div>
                  <div className="card-chip"></div>
                  <div className="card-number">•••• •••• •••• ••••</div>
                </div>
                <div className="card purple-card-2">
                  <div className="card-logo">K</div>
                  <div className="card-chip"></div>
                  <div className="card-number">•••• •••• •••• ••••</div>
                </div>
              </div>
              <div className="shopping-cart">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="8" cy="21" r="1"></circle>
                  <circle cx="19" cy="21" r="1"></circle>
                  <path d="m2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RevolutionizedHeroSection;
